// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Product from "./product.js"
import Tenant from "./tenant.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "fixed_delivery_price": {
      "column": null,
      "name": "fixed_delivery_price",
      "selected_by_default": null,
      "translated": null
    },
    "fixed_delivery_price_product_id": {
      "column": {
        "default": null,
        "name": "fixed_delivery_price_product_id",
        "null": true,
        "type": "uuid"
      },
      "name": "fixed_delivery_price_product_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "password": {
      "column": null,
      "name": "password",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "username": {
      "column": null,
      "name": "username",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "TenantShipmondoSetting",
  "collectionKey": "tenant_shipmondo_settings",
  "collectionName": "tenant_shipmondo_settings",
  "i18nKey": "tenant_shipmondo_setting",
  "camelizedLower": "tenantShipmondoSetting",
  "name": "TenantShipmondoSetting",
  "nameDasherized": "tenant-shipmondo-setting",
  "pluralName": "tenant_shipmondo_settings",
  "ransackable_associations": [
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "fixed_delivery_price_product_id",
      "name": "fixed_delivery_price_product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "encrypted_password",
      "column": {
        "default": null,
        "name": "encrypted_password",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "encrypted_password_iv",
      "column": {
        "default": null,
        "name": "encrypted_password_iv",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "encrypted_username",
      "column": {
        "default": null,
        "name": "encrypted_username",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "encrypted_username_iv",
      "column": {
        "default": null,
        "name": "encrypted_username_iv",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "fixed_delivery_price_cents",
      "column": {
        "default": 0,
        "name": "fixed_delivery_price_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "fixed_delivery_price_currency",
      "column": {
        "default": "DKK",
        "name": "fixed_delivery_price_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "fixed_delivery_price_product_id",
      "column": {
        "default": null,
        "name": "fixed_delivery_price_product_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "fixed_delivery_price_product_id",
      "name": "fixed_delivery_price_product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    }
  ],
  "paramKey": "tenant_shipmondo_setting",
  "primaryKey": "id"
}

/** Frontend model for TenantShipmondoSetting. */
export default class TenantShipmondoSetting extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  fixedDeliveryPrice() {
    return this.readAttributeUnderscore("fixed_delivery_price")
  }

  /** @returns {boolean} */
  hasFixedDeliveryPrice() {
    const value = this.fixedDeliveryPrice()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  fixedDeliveryPriceProductId() {
    return this.readAttributeUnderscore("fixed_delivery_price_product_id")
  }

  /** @returns {boolean} */
  hasFixedDeliveryPriceProductId() {
    const value = this.fixedDeliveryPriceProductId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  password() {
    return this.readAttributeUnderscore("password")
  }

  /** @returns {boolean} */
  hasPassword() {
    const value = this.password()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  username() {
    return this.readAttributeUnderscore("username")
  }

  /** @returns {boolean} */
  hasUsername() {
    const value = this.username()

    return this._isPresent(value)
  }

  /** @returns {import("./product.js").default | null} */
  fixedDeliveryPriceProduct() {
    return this._readBelongsToReflection({modelClass: Product, reflectionName: "fixed_delivery_price_product"})
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  loadFixedDeliveryPriceProduct() {
    if (!("fixedDeliveryPriceProductId" in this)) throw new Error("Foreign key method wasn't defined: fixedDeliveryPriceProductId")

    const id = this.fixedDeliveryPriceProductId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "fixed_delivery_price_product",
        model: this,
        modelClass: Product
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  ensureFixedDeliveryPriceProductLoaded() {
    return this.ensureAssociationLoaded("fixed_delivery_price_product")
  }

  /** @returns {import("./tenant.js").default | null} */
  tenant() {
    return this._readBelongsToReflection({modelClass: Tenant, reflectionName: "tenant"})
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  loadTenant() {
    if (!("tenantId" in this)) throw new Error("Foreign key method wasn't defined: tenantId")

    const id = this.tenantId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "tenant",
        model: this,
        modelClass: Tenant
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  ensureTenantLoaded() {
    return this.ensureAssociationLoaded("tenant")
  }
}
